// extracted by mini-css-extract-plugin
module.exports = {"taxonomyTags":"taxonomyTags___6lXZj","taxonomyTag":"taxonomyTag___1H8GS"};